/* eslint-disable react/style-prop-object */
/* eslint-disable eqeqeq */
/* eslint-disable no-nested-ternary */
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import links from '../../../../../config/links';
import {
    ClubTierTypes,
    getClubGenderDisplay,
    getClubNameDisplay,
    getRequestToJoinDisplayData,
    hasSchoolLinked,
    isActive,
    isClubAdminOrOwner,
    isClubOwner,
    isFlexLeagueClub,
    isFreeCollegeClubOwnerOrAdmin,
    isFreeHighSchoolClub,
    isPersonalClub,
    isProCollegeClubAdminOrOwner,
    isTeamTennisClub,
    isTournamentClub,
} from '../../../../utils/clubs';
import { splitTitle } from '../../../../utils/formatting';
import { getClickAttrs } from '../../../Analytics/gtag';
import BackgroundImage from '../../../BackgroundImage';
import ShareUrlPopUp from '../../../InfoPopUps/ShareUrlPopUp';
import AddPhoto from '../../../PhotoUpload/AddPhoto';
import PopOverMenu from '../../../PopOverMenu';
import DescriptionStylable from '../../../text/DescriptionStylable';
import UpgradeToUtrCollegeButton from '../../../Upgrade/UpgradeToUtrCollege/upgradeToUtrCollegeButton';
import PostDualMatchPopup from '../../Popups/PostDualMatchPopup';
import ClubLeagues from '../ClubLeagues';
import CreateEventButton from '../CreateEventButton';
import SchedulePlayButton from '../SchedulePlayButton';
import Metric from './Metric';
import { useStatsig } from '../../../hooks/useStatsig';
import Img from '../../../Img';

import { isoCountryCode2 } from '../../../../utils/isoCountryCodes';
import { getClubInviteURL } from '../../../../utils/referrals';
import { Power6Types } from '../../../../utils/constants';

import { useGetClubOrganizerLeagues } from '../../../hooks/useGetClubOrganizerLeagues';

import styles from '../../../../pages/ClubProfiles/club.scss';

const _ = { isEmpty };

const ClubProfileHeader = props => {
    const {
        clubDetails,
        menuOptions,
        onSelected,
        submitting,
        clubType = 'clubs',
        handleOnRequestPaidHitClicked,
        isSendingPaidHitRequest,
        onRegistrationClick,
        clubTeamRatings,
        power6Data,
    } = props;
    const { checkGate, featureGates } = useStatsig();
    const collegeDualMatchFlagEnabled = checkGate(featureGates.COLLEGE_DUAL_MATCH);
    const isReferFriendsEnabled = checkGate(featureGates.FLEX_REFERRAL);
    const referralsEnabled = checkGate(featureGates.REFERRAL_SYSTEM);
    const isRostersRolloutEnabled = checkGate(featureGates.ROSTERS_ROLLOUT);
    const isClubRedirectEnabled = checkGate(featureGates.CLUB_LINKS_REDIRECT);
    const {
        clubProfileImages,
        tierType,
        schoolProfile,
        location,
        profilePhotoUrl,
        name,
        memberCount,
        eventCount,
        sanctioned,
        verificationApplicationStatus,
        id,
        clubMemberRequests,
        bannerUrl,
        clubSubType,
        statusType,
        isFreeCollege,
    } = clubDetails;

    const [requestToJoinButtonHover, setRequestToJoinButtonHover] = useState(false);
    const [openPostScorePopup, setPostScorePopup] = useState(false);
    const [headerBg, setHeaderBg] = useState(bannerUrl ? `/v1/club/${bannerUrl}` : '');
    const { organizerLeagues, isLoadingLeagues } = useGetClubOrganizerLeagues(id);

    const photoInputRef = useRef();
    let banner;

    useEffect(() => {
        return () => {
            if (banner) {
                // eslint-disable-next-line no-use-before-define
                banner.removeEventListener('load', updateBanner);
            }
        };
    }, []);

    useEffect(() => {
        console.log('bannerUrl update');
        setHeaderBg(bannerUrl ? `/v1/club/${bannerUrl}` : '');
        // eslint-disable-next-line no-use-before-define
        if (banner && !bannerUrl) {
            banner.parentNode.style.backgroundImage = null;
        }
    }, [bannerUrl]);

    const clubSubTypeId = clubSubType ? clubSubType.id : 0;
    const genderString = tierType && getClubGenderDisplay(tierType, clubSubTypeId);
    const displayName = tierType && getClubNameDisplay(tierType, schoolProfile, name);
    const title = splitTitle(displayName);
    const pendingReuests = clubMemberRequests ? clubMemberRequests.filter(request => request.status === 'Pending').length : 0;
    const requestToJoinDisplayData = getRequestToJoinDisplayData(clubDetails, requestToJoinButtonHover);
    const canRunEvents = !_.isEmpty(tierType) ? tierType.canRunEvents : false;
    const canPostScores = !_.isEmpty(tierType) ? tierType.canPostScores : false;
    const memberText = memberCount === 1 ? 'member' : 'members';
    const eventText = eventCount === 1 ? 'event' : 'events';

    // to get Power 6 value based on type
    const getPower6ValueByType = (type) => {
        if (isRostersRolloutEnabled) {
            return power6Data?.power6Rating;
        }
        switch (type) {
            case Power6Types.GENERAL:
                return schoolProfile?.power6;
            case Power6Types.MEN:
                return schoolProfile?.power6Men;
            case Power6Types.WOMEN:
                return schoolProfile?.power6Women;
            default:
                return null;
        }
    };

    // to check if Power 6 value exists based on type
    const hasPower6ValueByType = (type) => {
        if (isRostersRolloutEnabled) {
            return power6Data?.power6Rating !== null && power6Data?.power6Rating !== undefined;
        }
        switch (type) {
            case Power6Types.GENERAL:
                return !!(schoolProfile?.power6);
            case Power6Types.MEN:
                return !!(schoolProfile?.power6Men);
            case Power6Types.WOMEN:
                return !!(schoolProfile?.power6Women);
            default:
                return false;
        }
    };

    const getPower6Value = () => getPower6ValueByType(Power6Types.GENERAL);
    const getPower6MenValue = () => getPower6ValueByType(Power6Types.MEN);
    const getPower6WomenValue = () => getPower6ValueByType(Power6Types.WOMEN);
    const hasPower6Value = () => hasPower6ValueByType(Power6Types.GENERAL);
    const hasPower6MenValue = () => hasPower6ValueByType(Power6Types.MEN);
    const hasPower6WomenValue = () => hasPower6ValueByType(Power6Types.WOMEN);

    const getCoedHighSchoolDescItems = () => {
        const items = [];

        if (isRostersRolloutEnabled) {
            // When using rosters-api, show single Power 6 value
            const power6Value = getPower6Value();
            const hasPower6 = power6Value !== null && power6Value !== undefined;

            if (!hasPower6 && location) {
                items.push(location.display);
            }
            if (hasPower6) {
                const power6Formatted = power6Value.toFixed(2);
                items.push({ left: power6Formatted, right: ` Power 6` });
            }
        } else {
            // When using schoolProfile, show separate Boys/Girls values
            const power6MenValue = getPower6MenValue();
            const power6WomenValue = getPower6WomenValue();
            const hasMensPower6 = hasPower6MenValue();
            const hasWomensPower6 = hasPower6WomenValue();

            if (!(hasMensPower6 || hasWomensPower6) && location) {
                items.push(location.display);
            }
            if (hasMensPower6) {
                const power6MenFormatted = power6MenValue.toFixed(2);
                items.push({ left: power6MenFormatted, right: ` Power 6 Boys` });
            }
            if (hasWomensPower6) {
                const power6WomenFormatted = power6WomenValue.toFixed(2);
                items.push({ left: power6WomenFormatted, right: ` Power 6 Girls` });
            }
        }

        return items;
    };

    const getCoedHighSchoolDescItemsMobile = () => {
        const items = getCoedHighSchoolDescItems();
        if (!hasSchoolLinked(clubDetails)) {
            items.push({ left: `${memberCount}`, right: ` ${memberText}` });
            items.push({ left: `${eventCount}`, right: ` ${eventText}` });
        }
        return items;
    };

    const getSingleGenderSchoolDescItems = () => {
        const items = [];
        const power6Value = getPower6Value();
        const hasPower6 = hasPower6Value();

        if (!hasPower6 && location) {
            items.push(location.display);
        }
        if (hasPower6) {
            const power6Formatted = power6Value.toFixed(2);
            items.push({ left: power6Formatted, right: ` Power 6` });
        }

        return items;
    };

    const getSingleGenderSchoolDescItemsMobile = () => {
        const items = getSingleGenderSchoolDescItems();
        if (!hasSchoolLinked(clubDetails)) {
            items.push({ left: `${memberCount}`, right: ` ${memberText}` });
            items.push({ left: `${eventCount}`, right: ` ${eventText}` });
        }
        return items;
    };

    const isFlexLeague = isFlexLeagueClub(tierType);
    const isAdultTeamTennisClub = isTeamTennisClub(tierType);
    const isUSClub = location?.countryCode2 === isoCountryCode2.USA;
    const isPaidHitClub = tierType?.id == ClubTierTypes.PAID_HIT;
    const user = useSelector((state) => state.auth?.user);
    const clubInviteURL = getClubInviteURL(clubDetails, user, referralsEnabled, isClubRedirectEnabled);
    const canAddMembers = isClubAdminOrOwner(clubDetails) && (tierType?.isHighSchool || tierType?.isCollege);
    const showReferFriendsButton = isFlexLeague && isUSClub && isReferFriendsEnabled;

    const getButtonText = () => {
        if (id === 10476) {
            return 'Register for MatchPlay';
        }
        if (isFlexLeague) {
            return 'Register for Flex Leagues';
        }
        if (submitting) {
            return 'Updating...';
        }

        return requestToJoinDisplayData.requestToJoinText;
    };

    const canUpgradeToPerformanceHs = isClubOwner(clubDetails) &&
        isFreeHighSchoolClub(tierType.name);

    const onCollegeConferenceDivisionClick = (ev) => {
        if (!!ev.target.textContent && ev.target.textContent.includes('Ranked')) {
            return props.history?.push('/college-corner/rankings');
        }
        const clubGenderParam = clubSubTypeId === 1 ? 'M' : (clubSubTypeId === 2 ? 'F' : null);
        const searchConferenceDivisionUrl = `/search?type=colleges${schoolProfile.conferenceId ? `&conference=${schoolProfile.conferenceId}` : ''}${schoolProfile.divisionId ? `&division=${schoolProfile.divisionId}` : ''}${clubGenderParam ? `&gender=${clubGenderParam}` : ''}`;
        props.history.push(searchConferenceDivisionUrl);
    };

    const onHighSchoolStateSubTitleClick = () => {
        const searchConferenceDivisionUrl = `/search?type=highSchools&locationCountryName=United%20States${location && location.stateName ? `&locationStateName=${location.stateName}` : ''}`;
        props.history.push(searchConferenceDivisionUrl);
    };

    const updateBanner = () => {
        if (banner) {
            const src = banner.currentSrc ? banner.currentSrc : banner.src;
            banner.parentNode.style.backgroundImage = `url("${src}")`;
        }
    };
    const setBannerRef = (img) => {
        banner = img;
        if (banner) {
            banner.addEventListener('load', updateBanner);
        }
    };

    const handleBannerPopoverClick = (item) => {
        switch (item.value) {
            case 'remove_banner':
                props.removeBannerPhoto(id);
                break;
            case 'upload_banner':
                photoInputRef.current.click();
                break;
            default:
                break;
        }
    };

    const linkCopied = () => {
        if (window?.analytics) {
            const path = '/share/club';
            const properties = {
                path,
                url: path,
                title: name,
            };

            window.analytics.page('share club profile', 'share link', properties);
        }
    };

    const getDefaultAvatar = () => {
        if (tierType.isCollege) {
            return '/img/v2/icons/icon-avatar-college.svg';
        }
        if (tierType.isHighSchool) {
            return '/img/v2/icons/icon-avatar-school.svg';
        }
        return '/img/v2/icons/icon-avatar-club.svg';
    };

    const handlePostDualMatch = () => {
        // segment track calls for college Post dual match button click - mapped to GA4
        if (window?.analytics) {
            window.analytics.track('Post Dual Match Button Clicked', {
                userId: user.id,
                collegeClubId: clubDetails.id,
            });
        }
        if (isActive(clubDetails)) {
            setPostScorePopup(true);
        }
    };

    const validateIfUserHasAccessToManageDualMatches = () => {
        if (collegeDualMatchFlagEnabled) {
            return (isProCollegeClubAdminOrOwner(clubDetails) || isFreeCollegeClubOwnerOrAdmin(clubDetails));
        }
    };

    return (
        <div className={`${styles.header}`}>
            <div className={`container`}>
                <div className={`${styles.clubDetails}`}>
                    <div className={`${styles.flexContainer}`}>
                        <div className={`${styles.flexColumn} ${styles.pictureContainer} ${styles.noHeight}`} />
                        <div className={`${styles.flexColumn} ${styles.detailsContainer} mt0`}>
                            {schoolProfile && tierType.isCollege && (
                                <React.Fragment>
                                    <div
                                        className={`${clubTeamRatings ? styles.subTitleBlue : styles.subTitle} d-block d-md-inline-block ${schoolProfile.conferenceShortName || schoolProfile.divisionShortName ? 'clickable' : ''}`}
                                        onClick={e => onCollegeConferenceDivisionClick(e)}
                                    >
                                        <DescriptionStylable
                                            desc={[
                                                ...(clubTeamRatings ? [`Ranked #${clubTeamRatings.rank}`] : []),
                                                (genderString + (schoolProfile?.divisionShortName ? ` ${schoolProfile.divisionShortName}` : '')),
                                                ...(schoolProfile?.conferenceShortName ? [schoolProfile.conferenceShortName] : []),
                                            ]}
                                        />
                                        <hr className={`mt8`} />
                                    </div>
                                </React.Fragment>
                            )}
                            {location?.stateName && tierType.isHighSchool && (
                                <React.Fragment>
                                    <div
                                        className={`${styles.subTitle} d-block d-md-inline-block ${location.stateName ? 'clickable' : ''}`}
                                        onClick={onHighSchoolStateSubTitleClick}
                                    >
                                        {`${location.stateName} High Schools${genderString.length > 0 ? ` - ${genderString}` : ''}`}
                                        <hr className={`mt8`} />
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                    <div className={`${styles.flexContainer}`}>
                        <div className={`${styles.flexColumn} ${styles.pictureContainer}`}>
                            <BackgroundImage
                                baseUrl={'/v1/club/'}
                                defaultImage={getDefaultAvatar()}
                                images={clubProfileImages}
                                imageType={'profile'}
                                parentStylesClass={styles.profilePicture}
                            />
                            {(isClubAdminOrOwner(clubDetails)) && (
                                <AddPhoto
                                    maxSize={512}
                                    uploadPhoto={props.handleUploadPhoto}
                                    uploadStart={props.handleUploadClubProfilePhotoStart}
                                    text={profilePhotoUrl ? 'Edit Photo' : 'Add Photo'}
                                    style={1}
                                    data-testid="club-profile.header.profile-photo-btn"
                                />
                            )}
                        </div>
                        <div className={`${styles.flexColumn} ${styles.detailsContainer}`}>
                            <h1 className={`${styles.title} d-block`} data-testid="club-profile.header.title">
                                {title.firstPart}
                                <span
                                    className={`${sanctioned ? 'verified' : ''}`}
                                >
                                    {title.lastPart}
                                </span>
                            </h1>
                            <div className={`${styles.subTitle} d-none d-md-block`} data-testid="club-profile.header.subtitle">
                                {(clubSubTypeId === 1 || clubSubTypeId === 2) && (
                                    <DescriptionStylable
                                        desc={getSingleGenderSchoolDescItems()}
                                        leftClassName={`text-bold`}
                                    />
                                )}
                                {(clubSubTypeId === 3 && tierType && tierType.isHighSchool) && (
                                    <DescriptionStylable
                                        desc={getCoedHighSchoolDescItems()}
                                        leftClassName={`text-bold`}
                                    />
                                )}
                            </div>
                            <div className={`${styles.subTitle} d-block d-md-none`}>
                                {(clubSubTypeId === 1 || clubSubTypeId === 2) && (
                                    <DescriptionStylable
                                        desc={getSingleGenderSchoolDescItemsMobile()}
                                        leftClassName={`text-bold`}
                                    />
                                )}
                                {(clubSubTypeId === 3 && tierType && tierType.isHighSchool) && (
                                    <DescriptionStylable
                                        desc={getCoedHighSchoolDescItemsMobile()}
                                        leftClassName={`text-bold`}
                                    />
                                )}
                            </div>
                            <div className={`${styles.actions}`}>
                                {isClubAdminOrOwner(clubDetails) && (
                                    <>
                                        {isFreeCollege && isClubOwner(clubDetails) ? (
                                            <UpgradeToUtrCollegeButton
                                                onClick={props.showLearnMoreUtrCollegePopup}
                                                small={true}
                                                user={user}
                                                clubStatus={statusType}
                                            />
                                        ) : (
                                            canRunEvents ? ((isClubAdminOrOwner(clubDetails) && isPersonalClub(tierType))
                                                ? (
                                                    <SchedulePlayButton
                                                        small={true}
                                                        onClick={props.onCreateEventClick}
                                                        clickLocation="Club Profile Header"
                                                    />
                                                ) : (
                                                    <CreateEventButton
                                                        small={true}
                                                        onClick={props.onCreateEventClick}
                                                        isTournamentClub={isTournamentClub(tierType)}
                                                        clickLocation="Club Profile Header"
                                                    />
                                                )
                                            ) : (
                                                <React.Fragment />
                                            )
                                        )}
                                    </>
                                )}
                                {(requestToJoinDisplayData.showRequestToJoin && !isAdultTeamTennisClub) && (
                                    <React.Fragment>
                                        <button
                                            type="button"
                                            className={`d-none d-md-block btn btn-primary btn-sm text-uppercase ${styles.primaryActionButton} ${styles.requestToJoinButton}`}
                                            data-testid="club-profile.header.request-to-join-btn-desktop"
                                            onMouseEnter={() => setRequestToJoinButtonHover(true)}
                                            onMouseLeave={() => setRequestToJoinButtonHover(false)}
                                            onClick={(e) => {
                                                if (id === 10476 || isFlexLeague) {
                                                    props.history.push(`/clubs/${id}?t=3`);
                                                    e.preventDefault();
                                                    // Scroll to a certain element
                                                    const currentTab = document.getElementsByClassName('btn-tab active');
                                                    onRegistrationClick(e);
                                                    currentTab[0]?.scrollIntoView(); //eslint-disable-line
                                                } else {
                                                    props.handleRequestToJoinClick();
                                                }
                                            }}
                                            disabled={(id === 10476 || isFlexLeague) ? false : submitting || !requestToJoinDisplayData.requestToJoinEnabled}
                                        >
                                            {getButtonText()}
                                        </button>
                                        <button
                                            type="button"
                                            className={`d-block d-md-none btn btn-primary btn-sm text-uppercase ${styles.primaryActionButton} ${styles.requestToJoinButton} ${!requestToJoinDisplayData.requestToJoinEnabled && id !== 10476 ? `disabled ${styles.disabled}` : ''}`}
                                            data-testid="club-profile.header.request-to-join-btn-mobile"
                                            onClick={(ev) => {
                                                if (id === 10476 || isFlexLeague) {
                                                    props.history.push(`/clubs/${id}?t=3`);
                                                    ev.preventDefault();
                                                    // Scroll to a certain element
                                                    const currentTab = document.getElementsByClassName('btn-tab active');
                                                    onRegistrationClick(ev);
                                                    currentTab[0]?.scrollIntoView(); //eslint-disable-line
                                                } else if (requestToJoinButtonHover === false && (ev.target.textContent == 'You\'re a Member' || ev.target.textContent == 'Following')) {
                                                    setRequestToJoinButtonHover(true);
                                                } else {
                                                    props.handleRequestToJoinClick();
                                                }
                                            }}
                                            disabled={(id === 10476 || isFlexLeague) ? false : submitting || !requestToJoinDisplayData.requestToJoinEnabled}
                                        >
                                            {getButtonText()}
                                        </button>
                                    </React.Fragment>
                                )}
                                {!!organizerLeagues.length && !isLoadingLeagues && (<ClubLeagues leagues={organizerLeagues} />)}
                                {isPaidHitClub && (
                                    <button
                                        type="button"
                                        className={`${styles.paidHitButton} btn btn-primary btn-sm text-uppercase`}
                                        data-testid="club-profile.header.request-paid-hit-btn"
                                        onClick={handleOnRequestPaidHitClicked}
                                        disabled={isSendingPaidHitRequest}
                                    >
                                        {isSendingPaidHitRequest ? 'Sending...' : 'Request Paid Hit'}
                                    </button>
                                )}
                                {showReferFriendsButton && (
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm text-uppercase"
                                        data-testid="club-profile.header.refer-friends-btn"
                                        onClick={() => {
                                            props.history.push('/flex-league-referral');
                                        }}
                                    >
                                        Refer Friends
                                    </button>
                                )}
                                {(isClubAdminOrOwner(clubDetails) && canPostScores) && (
                                    <button
                                        type="button"
                                        className={`btn btn-default btn-sm text-uppercase`}
                                        data-testid="club-profile.header.post-scores-btn"
                                        onClick={() => {
                                            if (!isActive(clubDetails)) {
                                                // setState({ showInactivePopup: true });
                                            } else {
                                                props.history.push(`/${clubType}/${clubDetails.id}/post-score`);
                                            }
                                        }}
                                        {...getClickAttrs({
                                            category: 'Post Score',
                                            context: 'Post Score button click',
                                            location: 'Club Profile CTA',
                                        })}
                                    >
                                        Post Scores
                                    </button>
                                )}
                                {!!validateIfUserHasAccessToManageDualMatches() && (
                                    <>
                                        <PostDualMatchPopup
                                            isOpen={openPostScorePopup}
                                            onToggle={setPostScorePopup}
                                            clubDetails={clubDetails}
                                            {...props}
                                        />
                                        <button
                                            type="button"
                                            className={`btn btn-primary btn-sm text-uppercase ${styles.primaryActionButton}`}
                                            data-testid="club-profile.header.post-dual-match-btn"
                                            onClick={handlePostDualMatch}
                                            {...getClickAttrs({
                                                category: 'Post Score',
                                                context: 'Post Dual Match button click',
                                                location: 'Club Profile CTA',
                                            })}
                                        >
                                            Post Dual Match
                                        </button>
                                    </>

                                )}
                                {isClubAdminOrOwner(clubDetails) && (
                                    <PopOverMenu
                                        anchorClass={`${styles.popOverMenuAnchor}`}
                                        horizontalEllipsis={false}
                                        menuItems={menuOptions}
                                        onSelected={onSelected}
                                        data-testid="club-profile.header.admin-menu"
                                    />
                                )}
                                {!isTournamentClub(tierType) && (
                                    <div className={`d-none d-md-block`}>
                                        <ShareUrlPopUp
                                            title="Share Club"
                                            className={`text-uppercase`}
                                            url={`${clubInviteURL}`}
                                            data-testid="club-profile.header.share-popup-desktop"
                                            linkCopied={linkCopied}
                                        />
                                    </div>
                                )}
                                {isClubAdminOrOwner(clubDetails) && pendingReuests > 0 && (
                                    <div
                                        className={`cursor-pointer text-uppercase`}
                                        data-testid="club-profile.header.pending-requests-btn"
                                        onClick={props.openPendingRequests}
                                    >
                                        <span className={`d-inline-block ${styles.pendingCount}`}>{pendingReuests}</span>
                                        <span className={`d-none d-md-inline-block ml8`}>{`New request${pendingReuests == 1 ? '' : 's'}`}</span>
                                    </div>
                                )}
                            </div>
                            {isClubAdminOrOwner(clubDetails) && !sanctioned && verificationApplicationStatus && (
                                <div className={`${styles.subTitle} mt8`}>Verified Status: {verificationApplicationStatus}</div>
                            )}

                            <div className={`${styles.learnMoreaddMember}`}>

                                {isClubOwner(clubDetails) && isFreeCollege && (
                                    <div className="mt8">
                                        <a
                                            href={links.collegeSupportSolutions}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={`${styles.learnMore} clickable`}
                                        >
                                            Learn More
                                        </a>
                                    </div>
                                )}
                                {(canAddMembers) && (
                                    <div className="mt8">
                                        <a
                                            href={`/${clubType}/${id}/add-members`}
                                            className={`${styles.inviteClubMembersLink} underline`}
                                            data-testid="club-profile.header.add-members-btn"
                                            onClick={(ev) => {
                                                ev.preventDefault();
                                                props.history.push(`/${clubType}/${id}/add-members`);
                                            }}
                                            {...getClickAttrs({
                                                category: 'Add members',
                                                context: `+ Add ${tierType.isCollege ? 'Members' : 'Players'} button click`,
                                                location: 'Club Profile CTA',
                                            })}
                                        >
                                            + Add {tierType.isCollege ? 'Members' : 'Players'}
                                        </a>
                                        {canUpgradeToPerformanceHs && (
                                            <a
                                                href="#"
                                                className={`underline ml24`}
                                                onClick={props.showUpgradeToPerformanceHsPopup}
                                                {...getClickAttrs({
                                                    category: 'Upgrade to Performance High School',
                                                    context: `+ Upgrade to Performance High School button click`,
                                                    location: 'Club Profile CTA',
                                                })}
                                            >
                                                + Upgrade to Performance High School
                                            </a>
                                        )}
                                    </div>
                                )}
                            </div>

                        </div>
                        <div className={`${styles.flexColumn} ${styles.metricsContainer}`}>
                            {!isTournamentClub(tierType) && (
                                <div className={`${styles.metricsWrapper}`}>
                                    {!(hasSchoolLinked(clubDetails) || isAdultTeamTennisClub) && (
                                        <>
                                            <Metric
                                                name={memberCount === 1 ? 'Member' : 'Members'}
                                                value={memberCount}
                                            />
                                            <Metric
                                                name={eventCount === 1 ? 'Event' : 'Events'}
                                                value={eventCount}
                                            />
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className={`${styles.flexColumn} ${styles.shareContainer}`}>
                            <ShareUrlPopUp
                                title="Share Club"
                                className={`text-uppercase`}
                                data-testid="club-profile.header.share-popup-mobile"
                                url={`${clubInviteURL}`}
                                linkCopied={linkCopied}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {!isTournamentClub(tierType) && (bannerUrl || isClubAdminOrOwner(clubDetails)) && !isAdultTeamTennisClub && (
                <div
                    className={`${styles.backgroundImage}`}
                >
                    {headerBg && (
                        <Img
                            src={headerBg}
                            onImgLoad={setBannerRef}
                            srcSet={`
                                ${headerBg}?size=1x&type=banner 1x,
                                ${headerBg}?size=2x&type=banner 2x,
                                ${headerBg}?size=3x&type=banner 3x
                            `}
                        />
                    )}
                    {(isClubAdminOrOwner(clubDetails)) && (
                        <div className={`${styles.editBanner}`}>
                            <PopOverMenu
                                menuItems={[
                                    ...([{ value: 'upload_banner', label: 'Upload' }]),
                                    ...bannerUrl ? ([{ value: 'remove_banner', label: 'Remove' }]) : [],
                                ]}
                                onSelected={handleBannerPopoverClick}
                                data-testid="club-profile.header.banner-menu"
                            >
                                <button
                                    type="button"
                                    className="btn btn-lg btn-primary button-float text-uppercase"
                                >
                                    Edit Banner <i className="uts uts-expand mr0" />
                                </button>
                            </PopOverMenu>
                            <AddPhoto
                                maxSize={2048}
                                uploadPhoto={props.handleUploadPhoto}
                                uploadStart={props.handleUploadPhotoStart}
                                text={'Upload'}
                                style={2}
                                inputRef={photoInputRef}
                            />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

ClubProfileHeader.propTypes = {
    clubDetails: PropTypes.shape({
        clubProfileImages: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string,
            url: PropTypes.string,
            type: PropTypes.string,
            size: PropTypes.number,
        })),
        tierType: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            isCollege: PropTypes.bool,
            isHighSchool: PropTypes.bool,
            canRunEvents: PropTypes.bool,
            canPostScores: PropTypes.bool,
        }),
        schoolProfile: PropTypes.shape({
            conferenceId: PropTypes.string,
            divisionId: PropTypes.string,
            conferenceShortName: PropTypes.string,
            divisionShortName: PropTypes.string,
            power6: PropTypes.number,
            power6Men: PropTypes.number,
            power6Women: PropTypes.number,
        }),
        location: PropTypes.shape({
            countryCode2: PropTypes.string,
            stateName: PropTypes.string,
            display: PropTypes.string,
        }),
        profilePhotoUrl: PropTypes.string,
        name: PropTypes.string,
        memberCount: PropTypes.number,
        eventCount: PropTypes.number,
        sanctioned: PropTypes.bool,
        verificationApplicationStatus: PropTypes.string,
        id: PropTypes.string,
        clubMemberRequests: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string,
            status: PropTypes.string,
            userId: PropTypes.string,
            createdAt: PropTypes.string,
        })),
        bannerUrl: PropTypes.string,
        clubSubType: PropTypes.shape({
            id: PropTypes.number,
        }),
        statusType: PropTypes.string,
        isFreeCollege: PropTypes.bool,
    }).isRequired,
    menuOptions: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    })).isRequired,
    submitting: PropTypes.bool.isRequired,
    clubType: PropTypes.string,
    onSelected: PropTypes.func.isRequired,
    handleOnRequestPaidHitClicked: PropTypes.func.isRequired,
    isSendingPaidHitRequest: PropTypes.bool,
    userLoggedIn: PropTypes.shape({
        id: PropTypes.string,
        email: PropTypes.string,
        isPowered: PropTypes.bool,
        isProClubHeadOrganizer: PropTypes.bool,
        clubMemberships: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string,
            role: PropTypes.string,
        })),
        memberPromoCreditBalance: PropTypes.number,
    }).isRequired,
    onRegistrationClick: PropTypes.func.isRequired,
    clubTeamRatings: PropTypes.shape({
        rank: PropTypes.number,
    }),
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
    handleUploadPhoto: PropTypes.func.isRequired,
    handleUploadClubProfilePhotoStart: PropTypes.func.isRequired,
    handleUploadPhotoStart: PropTypes.func.isRequired,
    removeBannerPhoto: PropTypes.func.isRequired,
    openPendingRequests: PropTypes.func.isRequired,
    showLearnMoreUtrCollegePopup: PropTypes.func.isRequired,
    showUpgradeToPerformanceHsPopup: PropTypes.func.isRequired,
    onCreateEventClick: PropTypes.func.isRequired,
    handleRequestToJoinClick: PropTypes.func.isRequired,
    power6Data: PropTypes.shape({
        power6Rating: PropTypes.number,
        power6HighRating: PropTypes.number,
        power6LowRating: PropTypes.number,
    }),
};

ClubProfileHeader.defaultProps = {
    clubType: 'clubs',
    isSendingPaidHitRequest: false,
    clubTeamRatings: null,
    power6Data: null,
};

export default withRouter(ClubProfileHeader);
